var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMejoraPerfilZj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 84,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.24 4.872v74.36c0 2.392 1.976 4.368 4.472 4.368h56.576a4.439 4.439 0 004.472-4.472V19.952L46.104.4H4.712A4.439 4.439 0 00.24 4.872z",
    fill: "#FFB092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.105.4l19.551 19.552h-16.12c-1.872 0-3.328-1.456-3.328-3.328L46.105.4z",
    fill: "#FF662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.817 25.984a9.568 9.568 0 100-19.136 9.568 9.568 0 000 19.136z",
    fill: "#FFCAB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.816 17.56a3.224 3.224 0 100-6.448 3.224 3.224 0 000 6.448z",
    fill: "#8182BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.816 25.984c3.224 0 6.032-1.56 7.696-3.952-1.56-2.704-4.368-4.576-7.696-4.576a8.758 8.758 0 00-7.696 4.576c1.768 2.392 4.576 3.952 7.696 3.952z",
    fill: "#8182BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.648 37.528h-49.4C7.52 37.528 7 37.008 7 36.28s.52-1.248 1.248-1.248h49.4c.728 0 1.248.52 1.248 1.248s-.52 1.248-1.248 1.248zM57.648 48.864h-49.4c-.728 0-1.248-.52-1.248-1.248s.52-1.248 1.248-1.248h49.4c.728 0 1.248.52 1.248 1.248s-.52 1.248-1.248 1.248zM57.648 60.2h-49.4C7.52 60.2 7 59.68 7 58.952s.52-1.248 1.248-1.248h49.4c.728 0 1.248.52 1.248 1.248s-.52 1.248-1.248 1.248zM33 71.536H8.248c-.728 0-1.248-.52-1.248-1.248s.624-1.248 1.248-1.248h24.648c.728 0 1.248.52 1.248 1.248s-.52 1.248-1.144 1.248z",
    fill: "#585992"
  })));
}
export default __webpack_public_path__ + "static/media/mejoraPerfil-zj.151760c2.svg";
export { SvgMejoraPerfilZj as ReactComponent };